import React, { useState, useEffect } from "react";
import { postData, getData } from "../../../global/Globalapi";
import { FaChevronRight, FaChevronDown } from "react-icons/fa";
const ActiveCount = () => {
  const [analyticsData, setAnalyticsData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeFilter, setActiveFilter] = useState("all");
  const [activeTable, setActiveTable] = useState("orders"); // 'orders' or 'active_users'
  const [activeUsersData, setActiveUsersData] = useState([]);
  const [expandedOrders, setExpandedOrders] = useState({});
  useEffect(() => {
    fetchAnalyticsData();
  }, []);

  const fetchAnalyticsData = async () => {
    try {
      const response = await postData("/orders/analytics", {});
      setAnalyticsData(response.data?.data || []);

      // Fetch active users data
      await fetchActiveUsersData();

      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  // const fetchActiveUsersData = async () => {
  //   try {
  //     const response = await getData('/user-activity')
  //     setActiveUsersData(response.data?.data || [])
  //   } catch (err) {
  //     console.error('Error fetching active users:', err)
  //   }
  // }

  // const fetchActiveUsersData = async () => {
  //   try {
  //     // --- Option 1: Read from localStorage (from Analytics tracking) ---
  //     const storedVisits = JSON.parse(localStorage.getItem("visitedUrls") || "[]")

  //     // Optional: Filter by last X minutes or unique IPs for “active” users
  //     const now = new Date()
  //     const activeWindowMinutes = 30
  //     const activeUsers = storedVisits.filter((visit) => {
  //       const visitTime = new Date(visit.time)
  //       const diffMinutes = (now - visitTime) / (1000 * 60)
  //       return diffMinutes <= activeWindowMinutes
  //     })

  //     // Remove duplicates by IP or URL (optional)
  //     const uniqueUsers = Array.from(
  //       new Map(activeUsers.map((u) => [u.ip, u])).values()
  //     )

  //     // Update your state
  //     setActiveUsersData(uniqueUsers)
  //     console.log("✅ Active users from GA/local tracking:", uniqueUsers)
  //   } catch (err) {
  //     console.error("Error fetching active users:", err)
  //   }
  // }
  const fetchActiveUsersData = async () => {
    try {
      const storedVisits = JSON.parse(
        localStorage.getItem("visitedUrls") || "[]",
      );

      const now = new Date();
      const activeWindowMinutes = 30;

      const activeUsers = storedVisits.filter((visit) => {
        const visitTime = new Date(visit.time);
        const diffMinutes = (now - visitTime) / (1000 * 60);
        return diffMinutes <= activeWindowMinutes;
      });

      const uniqueUsers = Array.from(
        new Map(activeUsers.map((u) => [u.ip, u])).values(),
      );

      // Map data to match your table columns
      const formattedUsers = uniqueUsers.map((u, index) => ({
        id: index + 1,
        user_id: u.ip || "N/A",
        last_request_time: u.time,
        ip_address: u.ip,
        endpoint: u.url,
        user_agent: u.userAgent || "Unknown",
        created_at: u.time,
        updated_at: u.time,
      }));

      setActiveUsersData(formattedUsers);
      console.log("✅ Active users from GA/local tracking:", formattedUsers);
    } catch (err) {
      console.error("Error fetching active users:", err);
    }
  };

  const filterData = () => {
    // if (activeFilter === 'all') {
    //   setFilteredData(analyticsData)
    //   return
    // }
    if (activeFilter === "all") {
      const sorted = [...analyticsData].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at),
      );
      setFilteredData(sorted);
      return;
    }
    const now = new Date();
    let filterDate = new Date();

    switch (activeFilter) {
      case "1hour":
        filterDate.setHours(now.getHours() - 1);
        break;
      case "24hours":
        filterDate.setDate(now.getDate() - 1);
        break;
      case "3days":
        filterDate.setDate(now.getDate() - 3);
        break;
      case "7days":
        filterDate.setDate(now.getDate() - 7);
        break;
      case "30days":
        filterDate.setDate(now.getDate() - 30);
        break;
      default:
        setFilteredData(analyticsData);
        return;
    }

    // const filtered = analyticsData.filter(order => {
    //   const orderDate = new Date(order.created_at)
    //   return orderDate >= filterDate
    // })
    const filtered = analyticsData
      .filter((order) => {
        const orderDate = new Date(order.created_at);
        return orderDate >= filterDate;
      })
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); // DESCENDING

    setFilteredData(filtered);
    setFilteredData(filtered);
  };

  useEffect(() => {
    filterData();
  }, [activeFilter, analyticsData]);

  const handleTableSwitch = (tableType) => {
    setActiveTable(tableType);
  };

  const getUniqueUsers = () => {
    const userMap = new Map();

    analyticsData.forEach((order) => {
      if (!userMap.has(order.user_id)) {
        userMap.set(order.user_id, {
          user_id: order.user_id,
          total_orders: 0,
          total_spent: 0,
          last_order_date: order.created_at,
          phone: order.phone,
          address: order.address,
        });
      }

      const user = userMap.get(order.user_id);
      user.total_orders += 1;
      user.total_spent += parseFloat(order.payedamount) || 0;

      if (new Date(order.created_at) > new Date(user.last_order_date)) {
        user.last_order_date = order.created_at;
      }
    });

    return Array.from(userMap.values());
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
        <div className="text-red-600 mb-2">
          <svg
            className="w-8 h-8 mx-auto mb-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-red-800 mb-2">
          Error Loading Data
        </h3>
        <p className="text-red-600">{error}</p>
        <button
          onClick={fetchAnalyticsData}
          className="mt-4 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
        >
          Try Again
        </button>
      </div>
    );
  }
  const toggleOrderExpand = (orderId) => {
    setExpandedOrders((prev) => ({
      ...prev,
      [orderId]: !prev[orderId],
    }));
  };
  const groupedOrders = filteredData.reduce((acc, order) => {
    const key = order.order_id;

    if (!acc[key]) {
      acc[key] = {
        ...order,
        products: [],
      };
    }

    acc[key].products.push({
      id: order.id,
      product_id: order.product_id,
      product_name: order.product_name || order.product_id || "N/A",
      quantity: order.quantity,
      amount: order.amount,
    });

    return acc;
  }, {});

  const groupedOrdersArray = Object.values(groupedOrders);
  const getDeliveryCharge = (order) => {
    const rawType =
      order.delivery_type ||
      order.delivery_option ||
      order.delivery_method ||
      order.address ||
      "";

    const deliveryType = String(rawType)
      .toLowerCase()
      .replace(/[\s:_-]/g, "");

    if (deliveryType.includes("homedelivery")) {
      return Number(order.home_delivery_amount || 0);
    }

    if (deliveryType.includes("takeaway")) {
      return Number(order.take_away_amount || 0);
    }

    if (deliveryType.includes("safedelivery")) {
      return Number(order.safe_delivery_amount || 0);
    }

    return 0;
  };
const formatDate = (date) => {
  if (!date) return { date: "-", time: "-" };

  const d = new Date(date);

  if (isNaN(d.getTime())) return { date: "-", time: "-" };

  return {
    date: d.toLocaleDateString("en-GB", {
      timeZone: "UTC", // ✅ For live
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }),

    time: d
      .toLocaleTimeString("en-IN", {
        timeZone: "UTC", // ✅ For live
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
      .toLowerCase(),
  };
};
  return (
    <div className="w-full p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2"> Dashboard</h1>
        <p className="text-gray-600">Monitor your orders and active users</p>
      </div>

      {/* Filter Dropdown */}
      <div className="mb-6">
        <select
          value={activeFilter}
          onChange={(e) => setActiveFilter(e.target.value)}
          className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="all">All Time</option>
          <option value="1hour">Last 1 Hour</option>
          <option value="24hours">Last 24 Hours</option>
          <option value="3days">Last 3 Days</option>
          <option value="7days">Last 7 Days</option>
          <option value="30days">Last 30 Days</option>
        </select>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
          <div className="flex items-center">
            <div className="p-2 bg-blue-100 rounded-lg">
              <svg
                className="w-6 h-6 text-blue-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Total Orders</p>
              <p className="text-2xl font-bold text-gray-900">
                {analyticsData.length}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
          <div className="flex items-center">
            <div className="p-2 bg-green-100 rounded-lg">
              <svg
                className="w-6 h-6 text-green-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">
                Successful Orders
              </p>
              <p className="text-2xl font-bold text-gray-900">
                {
                  analyticsData.filter((order) => order.status === "Success")
                    .length
                }
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
          <div className="flex items-center">
            <div className="p-2 bg-yellow-100 rounded-lg">
              <svg
                className="w-6 h-6 text-yellow-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
                />
              </svg>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Total Revenue</p>
              <p className="text-2xl font-bold text-gray-900">
                ₹
                {analyticsData
                  .reduce(
                    (sum, order) => sum + (parseFloat(order.payedamount) || 0),
                    0,
                  )
                  .toFixed(2)}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
          <div className="flex items-center">
            <div className="p-2 bg-purple-100 rounded-lg">
              <svg
                className="w-6 h-6 text-purple-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Active Users</p>
              <p className="text-2xl font-bold text-gray-900">
                {new Set(analyticsData.map((order) => order.user_id)).size}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Table Switch Buttons */}
      <div className="mb-6">
        <div className="flex flex-wrap gap-4">
          <button
            onClick={() => handleTableSwitch("orders")}
            className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
              activeTable === "orders"
                ? "bg-blue-600 text-white shadow-lg transform scale-105"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300 hover:shadow-md"
            }`}
          >
            <div className="flex items-center space-x-2">
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <span>Orders</span>
            </div>
          </button>

          <button
            onClick={() => handleTableSwitch("active_users")}
            className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
              activeTable === "active_users"
                ? "bg-blue-600 text-white shadow-lg transform scale-105"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300 hover:shadow-md"
            }`}
          >
            <div className="flex items-center space-x-2">
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
              <span>Active Users</span>
            </div>
          </button>
        </div>
      </div>

      {/* Orders Table Section */}
      {activeTable === "orders" && (
        <div className="w-full">
          <div className="mb-4">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Orders Details
            </h3>
          </div>

          {filteredData.length === 0 ? (
            <div className="bg-white border border-gray-300 rounded-lg shadow-md p-8 text-center">
              <div className="flex flex-col items-center">
                <svg
                  className="w-16 h-16 text-gray-400 mb-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  No Orders Found
                </h3>
                <p className="text-gray-500 mb-4">
                  {activeFilter === "all"
                    ? "No orders available in the system."
                    : `No orders found for the selected time period: ${
                        activeFilter === "1hour"
                          ? "Last 1 Hour"
                          : activeFilter === "24hours"
                            ? "Last 24 Hours"
                            : activeFilter === "3days"
                              ? "Last 3 Days"
                              : activeFilter === "7days"
                                ? "Last 7 Days"
                                : activeFilter === "30days"
                                  ? "Last 30 Days"
                                  : ""
                      }`}
                </p>
                <div className="text-sm text-gray-400">
                  Try selecting a different time period or check back later.
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="w-full overflow-x-auto">
                <table className="w-full table-fixed bg-white border border-gray-300 rounded-lg shadow-md">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 w-[120px] text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Order Date / Time
                      </th>
                      <th className="px-4 py-3  w-[140px] text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Order ID
                      </th>
                      <th className="px-4 py-3 w-[120px] text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        User Name
                      </th>
                      <th className="px-4 py-3 w-[130px] text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Phone
                      </th>
                      <th className="px-4 py-3 w-[180px] text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Product Name
                      </th>
                      <th className="px-4 py-3 w-[90px] text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Quantity
                      </th>
                      <th className="px-4 py-3 w-[110px] text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Amount
                      </th>
                      <th className="px-4 py-3 w-[130px] text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Delivery Charge
                      </th>
                      <th className="px-4 py-3 w-[120px] text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Total Paid
                      </th>
                      <th className="px-4 py-3 w-[100px] text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Status
                      </th>

                      <th className="px-4 py-3 w-[250px] text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Address
                      </th>
                    </tr>
                  </thead>
                  {/* <tbody className="bg-white divide-y divide-gray-200">
                    {filteredData.map((order, index) => (
                      <tr key={order.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}> */}
                  {/* Orders Table */}
                  {/* {filteredData.map((order, index) => ( */}
                  {/* <tr key={order.id || order.order_id || index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}> */}
                  {/* <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                          {new Date(order.created_at).toLocaleDateString()}
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {order.order_id}
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                          {order.first_name}
                        </td>
                         <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                          {order.phone}
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                         
                          {order.product_name || order.product_id || 'N/A'}
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                          {order.quantity}
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                          ₹{order.amount}
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                          ₹{order.payedamount}
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap">
                          <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                            order.status === 'Success' 
                              ? 'bg-green-100 text-green-800' 
                              : 'bg-red-100 text-red-800'
                          }`}>
                            {order.status}
                          </span>
                        </td>
                        
                        <td className="px-4 py-4 text-sm text-gray-500 whitespace-normal break-words max-w-md">
                          {order.address}
                        </td>
                      </tr>
                    ))}
                  </tbody> */}
                  <tbody className="bg-white divide-y divide-gray-200">
                    {groupedOrdersArray.map((order, index) => {
                      const isExpanded = expandedOrders[order.order_id];

                      return (
                        <React.Fragment key={order.order_id}>
                          <tr
                            className={
                              index % 2 === 0 ? "bg-white" : "bg-gray-50"
                            }
                          >
                            {/* <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                              {new Date(order.created_at).toLocaleDateString()}
                            </td> */}
  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
  <div className="flex flex-col leading-tight">
    <span className="font-medium text-gray-700">
      {formatDate(order.created_at).date}
    </span>
    <span className="text-xs text-gray-500 mt-1">
      {formatDate(order.created_at).time}
    </span>
  </div>
</td>
                            <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                              {order.order_id}
                            </td>

                            <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                              {order.first_name}
                            </td>

                            <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                              {order.phone}
                            </td>

                            <td className="px-4 py-4 text-sm text-gray-500">
                              <div className="flex items-center gap-2">
                                {order.products.length > 1 && (
                                  <span
                                    onClick={() =>
                                      toggleOrderExpand(order.order_id)
                                    }
                                    className="cursor-pointer text-gray-500 hover:text-black transition"
                                  >
                                    {isExpanded ? (
                                      <FaChevronDown size={12} />
                                    ) : (
                                      <FaChevronRight size={12} />
                                    )}
                                  </span>
                                )}

                                <span className="leading-tight">
                                  {order.products.length === 1
                                    ? order.products[0].product_name
                                    : order.products
                                        .map((p) => p.product_name)
                                        .join(", ")}
                                </span>
                              </div>
                            </td>

                            <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                              {order.products.reduce(
                                (sum, p) => sum + Number(p.quantity || 0),
                                0,
                              )}
                            </td>

                            <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                              ₹
                              {order.products
                                .reduce(
                                  (sum, p) => sum + Number(p.amount || 0),
                                  0,
                                )
                                .toFixed(2)}
                            </td>
                            <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                              ₹{getDeliveryCharge(order).toFixed(2)}
                            </td>
                            <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                              ₹{Number(order.payedamount || 0).toFixed(2)}
                            </td>

                            <td className="px-4 py-4 whitespace-nowrap">
                              <span
                                className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                                  order.status === "Success"
                                    ? "bg-green-100 text-green-800"
                                    : "bg-red-100 text-red-800"
                                }`}
                              >
                                {order.status}
                              </span>
                            </td>

                            <td className="px-4 py-4 text-sm text-gray-500 whitespace-normal break-words max-w-md">
                              {order.address}
                            </td>
                          </tr>

                          {isExpanded && (
                            <tr>
                              <td
                                colSpan="11"
                                className="px-6 py-4 bg-[#faf7f5]"
                              >
                                <div className="rounded-lg border border-gray-200 overflow-hidden">
                                  <table className="w-full">
                                    <thead className="bg-gray-100">
                                      <tr>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                                          Product ID
                                        </th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                                          Product Name
                                        </th>

                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                                          Quantity
                                        </th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                                          Amount
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {order.products.map((product, pIndex) => (
                                        <tr
                                          key={product.id || pIndex}
                                          className={
                                            pIndex % 2 === 0
                                              ? "bg-white"
                                              : "bg-gray-50"
                                          }
                                        >
                                          <td className="px-4 py-3 text-sm text-gray-700">
                                            {product.product_id}
                                          </td>
                                          <td className="px-4 py-3 text-sm text-gray-700">
                                            {product.product_name}
                                          </td>

                                          <td className="px-4 py-3 text-sm text-gray-700">
                                            {product.quantity}
                                          </td>
                                          <td className="px-4 py-3 text-sm text-gray-700">
                                            ₹
                                            {Number(
                                              product.amount || 0,
                                            ).toFixed(2)}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className="mt-4 text-sm text-gray-600">
                {/* Showing {filteredData.length} of {analyticsData.length} orders */}
                Showing {groupedOrdersArray.length} of{" "}
                {groupedOrdersArray.length} orders
                {activeFilter !== "all" && (
                  <span className="ml-2 text-blue-600">
                    (Filtered by{" "}
                    {activeFilter === "1hour"
                      ? "Last 1 Hour"
                      : activeFilter === "24hours"
                        ? "Last 24 Hours"
                        : activeFilter === "3days"
                          ? "Last 3 Days"
                          : activeFilter === "7days"
                            ? "Last 7 Days"
                            : activeFilter === "30days"
                              ? "Last 30 Days"
                              : ""}
                    )
                  </span>
                )}
              </div>
            </>
          )}
        </div>
      )}

      {/* Active Users Table Section */}
      {activeTable === "active_users" && (
        <div className="w-full">
          <div className="mb-4">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Active Users Details
            </h3>
          </div>

          {activeUsersData.length === 0 ? (
            <div className="bg-white border border-gray-300 rounded-lg shadow-md p-8 text-center">
              <div className="flex flex-col items-center">
                <svg
                  className="w-16 h-16 text-gray-400 mb-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1}
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  No Active Users Found
                </h3>
                <p className="text-gray-500 mb-4">
                  No active users available in the system.
                </p>
                <div className="text-sm text-gray-400">
                  Check back later for new users.
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="w-full overflow-x-auto">
                <table className="w-full bg-white border border-gray-300 rounded-lg shadow-md">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        ID
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        User ID
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Last Request Time
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        IP Address
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Endpoint
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        User Agent
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Created At
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                        Updated At
                      </th>
                    </tr>
                  </thead>

                  <tbody className="bg-white divide-y divide-gray-200">
                    {activeUsersData.map((user, index) => (
                      <tr
                        key={user.id}
                        className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                      >
                        <td className="px-4 py-3 text-sm text-gray-900">
                          {user.id}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-500">
                          {user.user_id}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-500">
                          {new Date(user.last_request_time).toLocaleString()}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-500">
                          {user.ip_address}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-500">
                          {user.endpoint}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-500">
                          {user.user_agent}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-500">
                          {new Date(user.created_at).toLocaleString()}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-500">
                          {new Date(user.updated_at).toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="mt-4 text-sm text-gray-600">
                Showing {activeUsersData.length} active users
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ActiveCount;
